import React, {useEffect, useState} from 'react';

function ValuePropTable({
    FBvalueProp,
    showEditMod,
    setShowEditMod,
    handleEdit,
    handleDelete
}) {

  const[FBVProp, setFBVProp] = useState([])
  const[first, setFirst] = useState(0)
  const[second, setSecond] = useState(10)
   
   useEffect(() => {
    setFBVProp(FBvalueProp.slice(first, second))
   }, [FBvalueProp, first, second])




    // console.log(FBvalueProp)
    return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Title
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Value Proposition
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Pain
                  </th>
                  <th scope="col" className="relative px-6 py-3">
                    <span className="sr-only">Edit</span>
                  </th>
                  <th scope="col" className="relative px-6 py-3">
                    <span className="sr-only">Delete</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {FBVProp.length > 0 ? FBVProp.map((FBvalueProp, index) => (
                  (FBvalueProp.ContextType === 'template' ? null :
                  <tr key={index} value={index} className={index % 2 === 0 ? 'bg-white border-b-2 border-gray-200' : 'bg-gray-50 border-b-2 border-gray-200'}>
                    <td className="px-6 py-4 whitespace-pre-line text-sm font-medium text-gray-900">{FBvalueProp.Title}</td>
                    <td className="px-6 py-4 whitespace-pre-line text-sm text-gray-500">{FBvalueProp.ValueProp}</td>
                    <td className="px-6 py-4 whitespace-pre-line text-sm text-gray-500">{FBvalueProp.Pain}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <button 
                        className="text-indigo-600 hover:text-indigo-900"
                        onClick={() => handleEdit(FBvalueProp)}
                    >
                        Edit
                      </button>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <button 
                        className="text-indigo-600 hover:text-indigo-900"
                        onClick={() =>handleDelete(FBvalueProp)}
                    >
                        Delete
                      </button>
                    </td>
                  </tr>
                  )
                )) : null}
              </tbody>
            </table>
            <nav
              className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
              aria-label="Pagination"
            >
              <div className="hidden sm:block">
                {FBvalueProp.length < 10 ? null :
                <p className="text-sm text-gray-700">
                    Showing <span className="font-medium">{first+1}</span> to <span className="font-medium">{second}</span> of{' '}
                  <span className="font-medium">{FBvalueProp.length}</span> results
                </p>}
              </div>
              <div className="flex-1 flex justify-between sm:justify-end">
                {first <=0 ? null :
                <button
                  type="button"
                  className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                  onClick={()=>{setFirst(first-10); setSecond(second-10)}}
                >
                  Previous
                </button>}
                {second >= FBvalueProp.length ? null :
                <button
                  type="button"
                  className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                  //onClick={()=>getNext()}
                  onClick={()=>{setFirst(first+10); setSecond(second+10)}}
                >
                  Next
                </button>}
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    )
}

export default ValuePropTable
